import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=1264666d&scoped=true"
import script from "./GoodsInfo.vue?vue&type=script&lang=js"
export * from "./GoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&id=1264666d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264666d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1264666d')) {
      api.createRecord('1264666d', component.options)
    } else {
      api.reload('1264666d', component.options)
    }
    module.hot.accept("./GoodsInfo.vue?vue&type=template&id=1264666d&scoped=true", function () {
      api.rerender('1264666d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore/steps/GoodsInfo.vue"
export default component.exports